/**
 * FieldCharCount Component
 *
 * Right-aligned "used / max" counter for a long-form Form field, turning red at
 * the cap so a truncated paste is visible rather than silent.
 *
 * Deliberately not antd's `showCount`: with showCount set, TextArea drops the
 * className and style from the <textarea> and puts them on a wrapper div, which
 * strips the shared .custom-textarea box off the field and leaves the count
 * floating outside it. Rendering the count here keeps the field styling intact
 * and gives the task and project description fields the same treatment.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import Text from 'antd/lib/typography/Text';
import '../../styles/index.scss';

const FieldCharCount = ({ name, max, className }) => (
  <Form.Item noStyle shouldUpdate={(prev, curr) => prev[name] !== curr[name]}>
    {({ getFieldValue }) => {
      const length = (getFieldValue(name) || '').length;
      return (
        <Text
          type={length >= max ? 'danger' : 'secondary'}
          className={`field-char-count ${className}`}
        >
          {length.toLocaleString()} / {max.toLocaleString()}
        </Text>
      );
    }}
  </Form.Item>
);

FieldCharCount.propTypes = {
  name: PropTypes.string.isRequired,
  max: PropTypes.number.isRequired,
  className: PropTypes.string,
};

FieldCharCount.defaultProps = {
  className: '',
};

export default FieldCharCount;
